<template>
    <div style="border: 1px solid transparent;">
        <div class="password-reset">
            <h1 class="title">新建工单</h1>
            <div class="password-reset-wrap">
                <!-- <div class="form-group">
                    <p>提交人</p>
                    <input ref="user" type="text" placeholder="请输入反馈人姓名" v-model="user">
                </div>

                <div class="form-group">
                    <p>联系方式</p>
                    <input ref="tel" type="text" placeholder="请输入反馈人联系方式" v-model="tel">
                </div>

                <div class="form-group">
                    <p>提交内容</p>
                    <textarea ref="content" v-model="content" class="feedcontent" name="feedcontent" id="" cols="30" rows="10" placeholder="请输入反馈内容"></textarea>
                </div> -->

                <div class="form-gorup button-group">
                    <el-button @click="cancel">取消</el-button>
                    <el-button @click="confirm" :loading="loading" type="primary">提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                user: '',
                tel: '',
                content:'',
                loading: false
            }
        },
        methods: {
            confirm(){
                var test =  /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                if(!test.test(this.tel)){
                    this.$e('请输入正确的手机号')
                    this.$refs['tel'].focus()
                    return
                }
                if( this.user == ''){
                    this.$message({type: 'warning', message: '请输入反馈人姓名'})
                    this.$refs['user'].focus()
                    return;
                }

                if( this.tel == ''){
                    this.$message({type: 'warning', message: '请输入反馈人联系方式'})
                    this.$refs['tel'].focus()
                    return;
                }

                if( this.content == ''){
                    this.$message({type: 'warning', message: '请输入反馈的内容'})
                    this.$refs['content'].focus()
                    return;
                }
                
                this.loading = true;
                this.$http.post('api/message/add', {
                    contact: this.user,
                    contactInformation: this.tel,
                    content: this.content
                }).then( res => {
                    this.loading = false;
                    this.$message({type: 'success', message: '提交成功'});
                    this.$store.commit('fadeOutComponent')
                }).catch( error => {
                    this.loading = false;
                    this.$message({type: 'error', message: error.msg})
                })
                // this.$router.push({path: '/personal'})
            },
            cancel(){
                this.$store.commit('fadeOutComponent')
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/component/base-feedback.vue